import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { unauthGuard } from './core/guards/unauth.guard';

export const routes: Routes = [ 
{
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout.component').then(c => c.AuthLayoutComponent),
    loadChildren: () =>  import('./features/auth/auth.routes').then(r => r.AUTH_ROUTES),
    canMatch: [unauthGuard]
  },  
  {
    // Standalone unit-testing page. No guards and no layout on purpose — it is
    // reachable without logging in.
    path: 'deal-test',
    loadComponent: () => import('./features/deal-test/deal-test').then(c => c.DealTest)
  },
  {
    path: 'site-coordinator',
    loadComponent: () => import('./layouts/site-coordinator-layout/site-coordinator-layout').then(c => c.SiteCoordinatorLayout),
    loadChildren: () =>  import('./features/site-coordinator/site-coordinator.routes').then(r => r.SITECOORDINATOR_ROUTES),
    canMatch: [authGuard, roleGuard],
    data: { roles: ['sitecoordinator'] }
  },   
  {
    path: '**',
    loadComponent: () => import('./layouts/site-coordinator-layout/site-coordinator-layout').then(c => c.SiteCoordinatorLayout),
    loadChildren: () =>  import('./features/system-error/system-error.routes').then(r => r.SYSTEMERRORLAYOUT_ROUTES),
  }, 
  
];
